module.exports = __webpack_public_path__ + "static/media/22_tn.c212ae09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/22_tn.jpg
// module id = 331
// module chunks = 0